import React from 'react';
import { useTranslatedStaticPage } from '@/hooks';
//
// import how1 from '../../../../public/pages/how-it-works/images/how-it-1.svg';
// import how2 from '../../../../public/pages/how-it-works/images/how-it-2.svg';
// import how3 from '../../../../public/pages/how-it-works/images/how-it-3.svg';
// import how4 from '../../../../public/pages/how-it-works/images/how-it-4.svg';
// import { useTranslation } from 'react-i18next';

export default function HowItWorksView() {
  const { content } = useTranslatedStaticPage('how-it-works');

  return (
    <div
      className='h-full bg-white dark:bg-[#242424] pb-48'
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
  // const { t } = useTranslation();
  // const steps = [
  //   t('Create Your Account'),
  //   t('Finish Tasks Everyday'),
  //   t('Earn Points and Tickets'),
  //   t('Participate in Giveaways Using Tickets'),
  //   t('Dominate Leaderboards Along the Way'),
  // ];
  // return (
  //   <div className='h-full bg-white '>
  //     {/* section 1 */}
  //     <div className='overflow-hidden	 sm:p-0 lg:p-10 bg-indigo-400 rounded-bl-custom-6 rounded-br-custom-6 sm:h-auto lg:min-h-500'>
  //       <div className='p-6 md:p-12 lg:px-36 flex flex-col gap-8 text-center'>
  //         <div className='text-4xl md:text-6xl font-bold text-white '>{t('What is Midle?')}</div>
  //         <div className='text-white font-normal md:w-3/4 mx-auto text-small'>
  //           {t(
  //             'Midle, a web 3.0-based marketing tool that brings together projects, influencers, DeFi/crypto communities, and users. Users will collect points by completing tasks and earn daily-reward according to their progress. The goal is to create a sustainable and effective crypto marketing method and to strengthen the loyalty between users and projects.',
  //           )}
  //         </div>
  //         <div className='w-full mt-4 p-4 gap-y-6  md:gap-y-11 flex flex-col md:flex-row md:flex-wrap justify-between relative '>
  //           <div className='opacity-0 md:opacity-100 border-2  border-dashed h-0 absolute w-10/12 top-10 left-1/2 transform -translate-x-1/2 border-indigo-200 border-b-indigo-500' />
  //           {steps.map((step, index) => (
  //             <div
  //               key={index}
  //               className='relative flex md:flex-col md:max-w-[120px] items-center gap-6  bg-indigo-400'
  //             >
  //               <div className='rounded-full bg-white w-14 h-14 flex items-center justify-center outline outline-offset-2 outline-4 outline-white text-indigo-500 '>
  //                 {index + 1}
  //               </div>
  //               <div className='flex md:block text-left md:text-center text-white font-semibold lg:text-lg'>
  //                 {step}
  //               </div>
  //             </div>
  //           ))}
  //         </div>
  //       </div>
  //     </div>
  //     {/* section 2 */}
  //     <div className=' flex flex-col lg:flex-row items-center gap-10 px-12 py-20 lg:px-20 xl:p-32'>
  //       <div className='flex-1'>
  //         <img src={how1} alt='img' className='mx-auto max-w-full' />
  //       </div>
  //       <div className='flex-1 lg:w-3/4 flex flex-col gap-y-10 justify-center items-center lg:items-start '>
  //         <div className='font-bold text-black text-2xl md:text-5xl'>Tasks</div>
  //         <div className='md:text-xl md:leading-7 font-normal	text-neutral-500 '>
  //           <p className='mb-2'>There are three types of tasks: Main, daily and monthly.</p>
  //           <ul className='list-disc  lg:w-3/5'>
  //             <li>Main tasks are finished once and their points are permanent.</li>
  //             <li>
  //               Daily tasks are refreshed every day and if not finished in time, users will miss
  //               their chance.
  //             </li>
  //             <li>
  //               Monthly tasks offer bigger point prizes and they have a full month countdown till
  //               they run out of time
  //             </li>
  //           </ul>
  //         </div>
  //       </div>
  //     </div>
  //     {/* section 3 */}
  //     <div className=' bg-indigo-100 flex flex-col lg:flex-row items-center  gap-10 px-12 py-20 lg:px-20 xl:p-32'>
  //       <div className='flex-1 flex flex-col gap-y-10 justify-center items-center lg:items-start'>
  //         <div className='font-bold text-black text-2xl md:text-5xl'>Points and Ticket</div>
  //
  //         <div className='md:text-xl md:leading-7 font-normal	text-neutral-500 '>
  //           <p className='mb-4'> Users collect points by completing tasks.</p>
  //           <ul className='list-disc mb-4'>
  //             <li>
  //               <strong>Every 200 points till 5000, every 100 points between 5000-10000</strong>
  //             </li>
  //             <li>
  //               <strong>Every 50 points after 10000 adds 1 ticket to user&apos;s balance.</strong>
  //             </li>
  //           </ul>
  //           <p>
  //             By collecting points, users will have the right of access to weekly and monthly
  //             giveaways. If a user has less than <strong>5000 points</strong> they can participate
  //             only in weekly giveaways. If a user has more than <strong>5000 points</strong>, they
  //             can participate in both <strong>weekly and monthly giveaways</strong>.
  //           </p>
  //           <p className='mt-4'>
  //             Use your exclusive invitation link to invite your friends to MIDLE! You will be
  //             earning 1 ticket per each account created with your link.
  //           </p>
  //         </div>
  //       </div>
  //       <div className='flex-1'>
  //         <img src={how2} alt='img' className='mx-auto max-w-full' />
  //       </div>
  //     </div>
  //     {/* section 4 */}
  //     <div className='flex flex-col lg:flex-row items-center  gap-10  px-12 py-20 lg:px-20 xl:p-32'>
  //       <div className='flex-1'>
  //         <img src={how3} alt='img' className='mx-auto max-w-full' />
  //       </div>
  //       <div className='flex-1 flex flex-col gap-y-10 justify-center items-center lg:items-start '>
  //         <div className='font-bold text-black text-2xl md:text-5xl'>Leaderboards</div>
  //
  //         <div className='md:text-xl md:leading-7 font-normal	text-neutral-500 '>
  //           <p>
  //             There are four types of leaderboards: Player based and clan based in monthly / all
  //             time forms. If a user dominates the monthly player leaderboard and reaches top 3, they
  //             will be winning exclusive prizes every month!{' '}
  //             <strong>
  //               Top 3 clans in the monthly clan leaderboard will be rewarding five members from each
  //               clan with exclusive prizes!
  //             </strong>
  //           </p>
  //         </div>
  //       </div>
  //     </div>
  //     {/* section 5 */}
  //     <div className='bg-indigo-100 flex flex-col lg:flex-row items-center  gap-10  px-12 py-20 lg:px-20 xl:p-32'>
  //       <div className='flex-1 flex flex-col gap-y-10 justify-center items-center lg:items-start '>
  //         <div className='flex-1 flex flex-col gap-y-10 justify-center items-center lg:items-start '>
  //           <div className='font-bold text-black text-2xl md:text-5xl'>Clans</div>
  //
  //           <div className='md:text-xl md:leading-7 font-normal	text-neutral-500 '>
  //             <p>
  //               Participate in a clan or create one together with your friends and dominate the
  //               world of MIDLE! Any user can create a clan or send requests to join other clans.
  //               Points collected by a user after joining a clan will also count for &quot;Clan
  //               Points&quot;. Clan leaders will be rewarded 1 ticket for every 500 points collected
  //               by clan members.
  //             </p>
  //           </div>
  //         </div>
  //       </div>
  //       <div className='flex-1'>
  //         <img src={how4} alt='img' className='mx-auto max-w-full' />
  //       </div>
  //     </div>
  //   </div>
  // );
}
